import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/api/queryClient';
import { ThemeProvider } from '@/components/ThemeProvider';
import { handleAuthCallback } from '@/auth/callback';
import App from './App';
import '@/styles/reset.css';
import '@/styles/tokens.css';
import '@/styles/globals.css';

// CRITICAL: parse the auth callback hash SYNCHRONOUSLY before React mounts.
// If we wait until ProtectedRoute's useEffect, child queries (Dashboard etc.)
// fire on first render without a token → 401 → redirect → infinite loop.
handleAuthCallback();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
